<div class="inner-content">
  <ion-buttons class="close-button">
    <ion-button color="dark" (click)="closeCardReaderModel(null)" fill="clear">
      <ion-icon slot="icon-only" name="close"></ion-icon>
    </ion-button>
  </ion-buttons>

  <!-- Header Information Section -->
  <div class="header-info" *ngIf="!cardReaderInitiated">
    <h2>{{'Total' | translate}}: {{ dataPayload.totalAmount | currency: basicInfo?.currencyCode }}</h2>
    <p>
      {{'Please apply any last-minute discounts or remove cents before connecting to the card reader. Once you connect, no further changes can be made' | translate}}.
    </p>
  </div>

  <!-- Action Buttons Section -->
  <div class="bg-light chip-row" *ngIf="!cardReaderInitiated">
    <span class="chip" (click)="openCustomDiscountModal()">+ {{'Add Discount' | translate}}</span>
    <span class="chip" (click)="removeCents()">{{'Remove Cents' | translate}}</span>
    <span class="chip" (click)="connectWithCardReader()">{{'Connect with Card Reader' | translate}}</span>
  </div>

  <!-- Card Reader Animation Section -->
  <div class="card-animation-wrapper">
    <div class="processing" *ngIf="!paymentDone && cardReaderInitiated">
      <div class="status">
        <span class="badge">{{'Reader Status' | translate}}</span>
        <div class="bg-app-2 msg">
          <div class="clock-loader"></div>
          {{ readerStatus }}
        </div>
      </div>
      <figure>
        <lottie-player class="lottie" autoplay loop *ngIf="cardAnimationJson" [src]="cardAnimationJson"></lottie-player>
      </figure>
      <div class="price">
        {{ dataPayload.totalAmount | currency: basicInfo?.currencyCode }}
        <small>{{'Total Amount' | translate}}</small>
      </div>
      <div class="payment-status outline-3 bg-app-2">
        <span class="label">{{'Payment Status' | translate}}</span>
        <span class="badge" [ngClass]="{
            pending: paymentStatus === 'Pending',
            failed: paymentStatus === 'Failed',
            initiated: paymentStatus === 'Payment Initiated..',
            processing: paymentStatus === 'Payment Proccessing...',
            'almost-finished':
              paymentStatus === 'Payment processing almost finished..',
            completed: paymentStatus === 'Payment is done successfully.'
          }">{{ paymentStatus }}</span>
      </div>
    </div>

    <!-- Payment Done Section -->
    <div class="payment-done" *ngIf="paymentDone">
      <lottie-player src="https://assets6.lottiefiles.com/packages/lf20_wkebwzpz.json" background="transparent"
        speed="1" loop autoplay></lottie-player>
      <div class="txt">{{'All Done' | translate}}</div>
      <span class="change" *ngIf="dataPayload.paymentType === 'cash'">
        {{'Change' | translate}}: {{ change | currency: basicInfo?.currencyCode }}
      </span>
    </div>
  </div>
</div>

<!-- Footer for Error Logs -->
<ion-footer>
  <ng-container *ngIf="errorLog">
    <h2 class="ion-text-center"> {{'Error' | translate}}: {{errorLog}}</h2>
  </ng-container>
</ion-footer>
